import S from 's-js';
import { IAjax } from 'lib/Ajax';
import { DraftObject } from 'lib/draftSignals';
import { AutoSaver } from 'lib/autoSave';

import { PCCache } from 'data/PCCache';

import { PilotJobOrder } from 'data/models/PilotJobOrder';
import { PilotJobOrderUserPreferences, PilotJobOrderUserPreferencesOptions } from 'data/models/PilotJobOrderUserPreferences';
import { UserSummary } from 'data/models/UserSummary';

export interface PilotJobOrderPreferencesParams {
    pjo : PilotJobOrder
}

export function PilotJobOrderPreferences(
    ajax : IAjax,
    data : PCCache,
    user : () => UserSummary | null,
    { pjo } : PilotJobOrderPreferencesParams
) {
    const
        userId = () => user() ? user()!.Id() : 0,
        preferencesClient = ajax.Url<PilotJobOrderUserPreferences, PilotJobOrderUserPreferencesOptions>(
            () => (pjo.UserPreferencesUrlBase() || '')
                .replace('{userId}', '' + userId())
        ),
        persistedPreferences = data.PilotJobOrderUserPreferenceses.index(() => PilotJobOrderUserPreferences.dataKey({
            PilotJobOrderId: pjo.Id(),
            UserId: userId()
        })),
        effectivePreferences = new PilotJobOrderUserPreferences(),
        { object: draftPreferences, methods: draftPreferencesMethods } = DraftObject(effectivePreferences);

    // TH 02/02/2017 -- Update effectivePreferences from persistedPreferences.
    S(() => persistedPreferences() &&
        PilotJobOrderUserPreferences.update(effectivePreferences, asOptions(persistedPreferences()!)));

    AutoSaver(draftPreferencesMethods.onWrite, () => {
        const req = preferencesClient.Put(draftPreferences),
            checkpoint = draftPreferencesMethods.checkpoint();
        return req.then(json => S.freeze(() => {
            data.PilotJobOrderUserPreferenceses.update1(req.Date, json);
            checkpoint.revert();
        }));
    });

    return {
        draftPreferences
    };
}
export type PilotJobOrderPreferences = ReturnType<typeof PilotJobOrderPreferences>;

// TH 02/08/2017 -- Ditto pilotsjoborderdetails\pilotassignments.ts about a generic utility
// and/or extension of auto-generated models?
function asOptions(prefs : PilotJobOrderUserPreferences) {
    return JSON.parse(JSON.stringify(prefs)) as PilotJobOrderUserPreferencesOptions;
}


// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/pilotjoborderpreferences.ts